import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=040cb16d&scoped=true&"
import script from "./OrderPanel.vue?vue&type=script&lang=js&"
export * from "./OrderPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrderPanel.vue?vue&type=style&index=0&id=040cb16d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040cb16d",
  null
  
)

export default component.exports